import React from 'react';
import { Row as RTRow } from 'react-table';

import { Table, TableBody, TableRow, TableCell, IconButton, Collapse } from '@mui/material';

import { withStyles, makeStyles } from 'tss-react/mui';

import ExpandMore from '@mui/icons-material/ExpandMore';
import ExpandLess from '@mui/icons-material/ExpandLess';


const CollapseTableRow = withStyles(TableRow, (theme) => ({
  root: {
    background: theme.palette.grey[50]
  },
}));

const CollapseTableCell = withStyles(TableCell, (_theme) => ({
  root: {
    padding: 0,
    border: 0,

  },

  sizeSmall: {
    '&:last-child': {
      paddingRight: 0,
    }
  }
}));


const useStyles = makeStyles()((theme) => ({
  headerCell: {
    paddingRight: 0,
  },
  buttonCell: {
    width: 0,
    padding: 0,
    paddingTop: 2,
    paddingBottom: 2,
    paddingRight: 2,
    textAlign: 'right',
  },
  fixedCollapsibleTable: {
    tableLayout: 'fixed',
  },
  tableRow: {
    background: theme.palette.common.white,
  },
  collapsedTableRow: {
    '& td': {
      borderBottomWidth: 0,
    },
    '&:last-child td': {
      borderBottomWidth: '1px',
    },
  },
  collapsedTableHeadCell: {
    whiteSpace: 'nowrap',
  },
  collapsedTableDataCell: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
}));


export type CollapsibleListRowProps = {
  row: RTRow<Record<string, unknown>>;
  tableColumnsCount: number;
  className?: string;
  disableCollapsibleRowFixedTableLayout?: boolean;
};


export const CollapsibleListRow = ({ row, tableColumnsCount, disableCollapsibleRowFixedTableLayout = false, ...rowProps }: CollapsibleListRowProps) => {
  const { classes, cx } = useStyles();
  const [ collapsed, setCollapsed ] = React.useState(false);

  return (
    <React.Fragment>
      <TableRow {...rowProps} className={cx(classes.tableRow, rowProps.className)} onClick={() => setCollapsed(!collapsed)}>
        {row.cells.slice(0, tableColumnsCount).map((cell) => {
          const { key, ...cellProps } = cell.getCellProps();

          return (
            <TableCell key={key} {...cellProps} className={classes.headerCell}>
              {cell.render('Cell')}
            </TableCell>
          );
        })}
        <TableCell className={classes.buttonCell}>
          <IconButton size="medium">
            {collapsed ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
        </TableCell>
      </TableRow>
      <CollapseTableRow>
        <CollapseTableCell colSpan={tableColumnsCount + 1}>
          <Collapse in={collapsed}>
            <Table className={cx({ [classes.fixedCollapsibleTable]: !disableCollapsibleRowFixedTableLayout })}>
              <TableBody>
                {row.cells.slice(tableColumnsCount).map(cell => {
                  const { key } = cell.getCellProps();

                  return (
                    <TableRow key={key} className={classes.collapsedTableRow}>
                      <TableCell className={classes.collapsedTableHeadCell} style={{ width: cell.row.cells[0].column.width }}>{cell.column.render('Header')}</TableCell>
                      <TableCell className={classes.collapsedTableDataCell}>{cell.render('Cell')}</TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </Collapse>
        </CollapseTableCell>
      </CollapseTableRow>
    </React.Fragment>
  );
};
